import { render, staticRenderFns } from "./ModalAssignResponsible.vue?vue&type=template&id=bbcd71f6"
import script from "./ModalAssignResponsible.vue?vue&type=script&lang=js"
export * from "./ModalAssignResponsible.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tomi/Projects/ingeniAR/rrhh/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bbcd71f6')) {
      api.createRecord('bbcd71f6', component.options)
    } else {
      api.reload('bbcd71f6', component.options)
    }
    module.hot.accept("./ModalAssignResponsible.vue?vue&type=template&id=bbcd71f6", function () {
      api.rerender('bbcd71f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/OrgChart/ModalAssignResponsible.vue"
export default component.exports